/**
 * Shared react-select option lists for the country and language pickers
 * (SCRUM-1027). Previously re-derived inline in seven containers, in four
 * different idioms, which had already drifted into two label formats.
 *
 * Built once at module load — the underlying JSON is static — and frozen so a
 * consumer cannot mutate the list every other picker shares.
 */
import CountriesData from "./CountryData/CountriesData.json";
import languagesData from "./LanguageData/languagesData.json";

export interface SelectOption {
  value: string;
  label: string;
}

/** Countries as "Name (CODE)" — the Site, User and Product pickers. */
export const COUNTRY_OPTIONS: readonly SelectOption[] = Object.freeze(
  CountriesData.map((c) => ({ value: c.code, label: `${c.name} (${c.code})` }))
);

/** Countries as bare "Name" — the Client pickers render no ISO code. */
export const COUNTRY_OPTIONS_NAME_ONLY: readonly SelectOption[] = Object.freeze(
  CountriesData.map((c) => ({ value: c.code, label: c.name }))
);

/**
 * Languages as "Name (nativeName)" — the Site pickers.
 *
 * Falls back to the bare name when nativeName is missing or blank. The
 * builders this module replaced interpolated unconditionally, so `lu` (which
 * carries nativeName: "" in the source JSON) rendered as "Luba-Katanga ()".
 */
export const LANGUAGE_OPTIONS: readonly SelectOption[] = Object.freeze(
  languagesData.map((l) => {
    const nativeName = String(l.nativeName ?? "").trim();
    return {
      value: l.code,
      label: nativeName ? `${l.name} (${nativeName})` : l.name,
    };
  })
);
